import apiRequest from '../../utils/bccampusApiRequest.js';

const verifyByRecaptchaToken = (token) =>
  `/download/verify/${encodeURIComponent(token)}`;

const verify = async (token) => {
  if (!token) return null;
  try {
    const result = await apiRequest({
      url: verifyByRecaptchaToken(token),
    });

    if (!result) throw new Error();
    return result;
    // if(!result.data || !result.data.length) throw new Error();
    // return result.data[0];
  } catch (err) {
    return {
      success: false,
      score: 0,
      action: "file_download",
      expires: 0,
      signatureHash: null,
    };
  }
};
const repository = { verify };

export { verify };
export default repository;
